import type { TweetListResponsePageAllOf } from './tweetListResponsePageAllOf';
import type { TweetListResponsePageAllOfThree } from './tweetListResponsePageAllOfThree';

export type TweetListResponsePage = TweetListResponsePageAllOf & TweetListResponsePageAllOfThree;
